export default {
    computed: {
        baseTableSettings: function() {
            return {
                borderless: true,
                noSortReset: true,
                showEmpty: true,
                emptyText: this.$t("table.empty"),
                emptyFilteredText: this.$t("table.filter.empty"),
                labelSortAsc: this.$t("table.sort.asc"),
                labelSortDesc: this.$t("table.sort.asc"),
                labelSortClear: this.$t("table.sort.asc"),
                sortNullLast: false,
                responsive: "xl"
            };
        },
        wonTableSettings: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.wonTableDataProvider,
                    fields: this.tenderTableFields,
                    tbodyTrClass: (item) => (
                        item && item.slug ? "clickable" : ""
                    )
                }
            };
        },
        lostTableSettings: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.lostTableDataProvider,
                    fields: this.lostTenderTableFields,
                    tbodyTrClass: (item) => (
                        item && item.slug ? "clickable" : ""
                    )
                }
            };
        },
        contractsTableSettings: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.contractsTableDataProvider,
                    fields: this.contractTableFields,
                    tbodyTrClass: (item) => (
                        item && item.slug ? "clickable" : ""
                    )
                }
            };
        },
        icontractsTableSettings: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.icontractsTableDataProvider,
                    fields: this.icontractTableFields,
                    tbodyTrClass: (item) => (
                        item && item.slug ? "clickable" : ""
                    )
                }
            };
        },
        concurrencyTableSettings: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.concurrencyTableDataProvider,
                    fields: this.concurrencyTableFields,
                    tbodyTrClass: (item) => (item && item.is_supplier ? "clickable" : "")
                }
            };
        },
        paymentsTableSettings: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.paymentsTableDataProvider,
                    fields: this.paymentsTableFields
                }
            };
        },
        paymentsTableSettingsAddInfo: function() {
            return {
                ...this.baseTableSettings,
                ...{
                    items: this.paymentsTableDataProvider,
                    fields: this.paymentsTableFieldsAddInfo
                }
            };
        },
        tenderTableFields: function() {
            return [
                {
                    key: "risk",
                    label: this.$t("supplierDetail.tenders.table.head.risk"),
                    thClass: "text-center",
                    class: "text-center text-nowrap"
                },
                {
                    key: "signature_date",
                    label: this.$t("supplierDetail.tenders.table.head.date"),
                    thClass: "text-end",
                    class: "text-end text-nowrap"
                },
                {
                    key: "title",
                    label: this.$t("supplierDetail.tenders.table.head.name"),
                    class: "text-start absorbing-column"
                },
                {
                    key: "price",
                    label: this.$t("supplierDetail.tenders.table.head.price"),
                    thClass: "text-end",
                    class: "text-end numeric"
                },
                {
                    key: "flags",
                    label: this.$t("supplierDetail.tenders.table.head.flagsCount"),
                    thClass: "text-end",
                    class: "text-center detailsButtonColumn p-0"
                }
            ];
        },
        lostTenderTableFields: function() {
            return [
                {
                    key: "signature_date",
                    label: this.$t("supplierDetail.tenders.table.head.date"),
                    thClass: "text-end",
                    class: "text-end text-nowrap"
                },
                {
                    key: "title",
                    label: this.$t("supplierDetail.tenders.table.head.name"),
                    class: "text-start "
                },
                {
                    key: "supplier_name",
                    label: this.$t("supplierDetail.tenders.table.head.winner"),
                    class: "text-start supplier-name-column"
                },
                {
                    key: "price",
                    label: this.$t("supplierDetail.tenders.table.head.price"),
                    thClass: "text-end",
                    class: "text-end numeric"
                }
            ];
        },
        contractTableFields: function() {
            return [
                {
                    key: "risk",
                    label: this.$t("supplierDetail.tenders.table.head.risk"),
                    thClass: "text-center",
                    class: "text-center text-nowrap"
                },
                {
                    key: "signature_date",
                    label: this.$t("supplierDetail.contracts.table.head.date"),
                    thClass: "text-end",
                    class: "text-end text-nowrap"
                },
                {
                    key: "title",
                    label: this.$t("supplierDetail.contracts.table.head.name"),
                    class: "text-start absorbing-column"
                },
                {
                    key: "robust_price_vat",
                    label: this.$t("supplierDetail.contracts.table.head.price"),
                    thClass: "text-end",
                    class: "text-end numeric"
                },
                {
                    key: "flags",
                    label: this.$t("supplierDetail.tenders.table.head.flagsCount"),
                    thClass: "text-end",
                    class: "text-center detailsButtonColumn p-0"
                }
            ];
        },
        icontractTableFields: function() {
            return [
                {
                    key: "risk",
                    label: this.$t("supplierDetail.tenders.table.head.risk"),
                    thClass: "text-center",
                    class: "text-center text-nowrap"
                },
                {
                    key: "signature_date",
                    label: this.$t("supplierDetail.contracts.table.head.date"),
                    class: "text-end text-nowrap"
                },
                {
                    key: "title",
                    label: this.$t("supplierDetail.contracts.table.head.name"),
                    class: "text-start absorbing-column"
                },
                {
                    key: "robust_price_vat",
                    label: this.$t("supplierDetail.contracts.table.head.price"),
                    thClass: "text-end",
                    class: "text-end numeric"
                },
                {
                    key: "flags",
                    label: this.$t("supplierDetail.tenders.table.head.flagsCount"),
                    thClass: "text-end",
                    class: "text-center detailsButtonColumn p-0"
                }
            ];
        },
        concurrencyTableFields: function() {
            return [
                {
                    key: "concurrents",
                    label: "",
                    class: "col-12",
                    thClass: "text-start",
                    class: "text-start"
                },
                {
                    key: "flags",
                    label: this.$t("supplierDetail.tenders.table.head.flagsCount"),
                    thClass: "text-end",
                    class: "text-center detailsButtonColumn"
                }
            ];
        },
        paymentsTableFields: function() {
            return [
                {
                    key: "date",
                    label: this.$t("supplierDetail.payments.table.head.date"),
                    class: "text-start text-nowrap"
                },
                {
                    key: "price_vat",
                    label: this.$t("supplierDetail.payments.table.head.price"),
                    thClass: "text-end",
                    class: "text-end numeric"
                }
            ];
        },
        paymentsTableFieldsAddInfo: function() {
            return [
                {
                    key: "date",
                    label: this.$t("supplierDetail.payments.table.head.date"),
                    class: "text-start text-nowrap"
                },
                {
                    key: "details",
                    label: this.$t("supplierDetail.payments.table.head.details")
                },
                {
                    key: "price_vat",
                    label: this.$t("supplierDetail.payments.table.head.price"),
                    thClass: "text-end",
                    class: "text-end numeric"
                }
            ];
        },
        contractsSortOptions: function() {
            return [
                { text: this.$t("ordering.options.age.desc"), value: { by: "signature_date", desc: true } },
                { text: this.$t("ordering.options.age.asc"), value: { by: "signature_date", desc: false } },
                { text: this.$t("ordering.options.price.desc"), value: { by: "robust_price_vat", desc: true } },
                { text: this.$t("ordering.options.price.asc"), value: { by: "robust_price_vat", desc: false } },
                { text: this.$t("ordering.options.alphabet.asc"), value: { by: "title", desc: false } }
            ];
        },
        wonTendersSortOptions: function() {
            return [
                { text: this.$t("ordering.options.age.desc"), value: { by: "signature_date", desc: true } },
                { text: this.$t("ordering.options.age.asc"), value: { by: "signature_date", desc: false } },
                { text: this.$t("ordering.options.risk.desc"), value: { by: "risk", desc: true } },
                { text: this.$t("ordering.options.risk.asc"), value: { by: "risk", desc: false } },
                { text: this.$t("ordering.options.flags.desc"), value: { by: "flags_count", desc: true } },
                { text: this.$t("ordering.options.flags.asc"), value: { by: "flags_count", desc: false } },
                { text: this.$t("ordering.options.price.desc"), value: { by: "price", desc: true } },
                { text: this.$t("ordering.options.price.asc"), value: { by: "price", desc: false } },
                { text: this.$t("ordering.options.alphabet.asc"), value: { by: "title", desc: false } }
            ];
        },
        lostTendersSortOptions: function() {
            return [
                { text: this.$t("ordering.options.age.desc"), value: { by: "signature_date", desc: true } },
                { text: this.$t("ordering.options.age.asc"), value: { by: "signature_date", desc: false } },
                { text: this.$t("ordering.options.price.desc"), value: { by: "price", desc: true } },
                { text: this.$t("ordering.options.price.asc"), value: { by: "price", desc: false } },
                { text: this.$t("ordering.options.alphabet.asc"), value: { by: "title", desc: false } }
            ];
        },
        paymentsSortOptions: function() {
            return [
                { text: this.$t("ordering.options.age.desc"), value: { by: "invoice_date", desc: true } },
                { text: this.$t("ordering.options.age.asc"), value: { by: "invoice_date", desc: false } },
                { text: this.$t("ordering.options.price.desc"), value: { by: "price_vat", desc: true } },
                { text: this.$t("ordering.options.price.asc"), value: { by: "price_vat", desc: false } }
            ];
        }
    }
};
